<template>
  <div class="latest-updates">
    <h2 class="latest-updates__title">Latest Updates</h2>
    <div class="latest-updates__list">
      <a
        v-for="(item, index) in latestItems"
        :key="index"
        :href="item.url"
        class="latest-updates__item"
      >
        <div class="latest-updates__item-img">
          <img :src="item.poster" :alt="item.title" loading="lazy">
        </div>
        <div class="latest-updates__item-content">
          <h3 class="latest-updates__item-title">{{ item.title }}</h3>
          <span class="latest-updates__item-date">{{ item.date }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import doc from '@/documents/blogs.js';

export default {
  name: 'LatestUpdates',
  props: {
    excludeUrl: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    latestItems() {
      const list = [...doc.bloglist.en];
      // 排除当前文章
      const filtered = this.excludeUrl
        ? list.filter((item) => item.url !== this.excludeUrl)
        : list;
      // 按日期倒序排列
      const sorted = filtered.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      // 取前 N 条
      return sorted.slice(0, this.limit);
    },
  },
};
</script>

<style scoped>
.latest-updates {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #e8e8e8;
}

.latest-updates__title {
  font-size: 1.5em;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #25d366;
  display: inline-block;
}

.latest-updates__list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.latest-updates__item {
  display: flex;
  gap: 14px;
  padding: 14px;
  background: #f9fafb;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  border: 1px solid #e8e8e8;
}

.latest-updates__item:hover {
  background: #f0fdf4;
  border-color: #25d366;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.12);
}

.latest-updates__item-img {
  flex-shrink: 0;
  width: 100px;
  height: 70px;
  overflow: hidden;
  border-radius: 6px;
}

.latest-updates__item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.latest-updates__item-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.latest-updates__item-title {
  font-size: 0.95em;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 6px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.latest-updates__item-date {
  font-size: 0.82em;
  color: #718096;
}

@media screen and (max-width: 768px) {
  .latest-updates__list {
    grid-template-columns: 1fr;
  }

  .latest-updates__item-img {
    width: 80px;
    height: 60px;
  }

  .latest-updates__item-title {
    font-size: 0.88em;
  }
}
</style>
